import { sortObj } from '~cartzillagb/util'
import {
	withUniqueClass,
	withBlockStyles
} from '~cartzillagb/higher-order'
import { compose } from '@wordpress/compose'
import { applyFilters } from '@wordpress/hooks'
import classnames from 'classnames'

import createStyles from './style'

const save = props => {

	const {
		blockName,
		styles,
		className,
		attributes,
	} = props

	const {
		blockId,
		enableContainer,

		// Carousel.
		enableCarousel,
	} = attributes

	const data = {
		'data-attributes': JSON.stringify( sortObj( attributes ) ),
	}

	const mainClasses = classnames( [
		'wp-block-czgb-brands',
		className,
	], {
		'cz-carousel' : enableCarousel
	} )

	return (
		<div id={ blockId } className={ mainClasses }>
			{ styles }
			<div className={ classnames( [], {
				'container' : enableContainer,
				'mb-5' : enableCarousel,
				'py-lg-4' : ! enableCarousel,
			} ) }>
				{ applyFilters( `cartzillagb.${ blockName }.save.output.block-title`, null, null, props ) }
				<div className={ 'ajax-content' } { ...data }></div>
			</div>
		</div>
	)
}

export default compose(
	withUniqueClass,
	withBlockStyles( createStyles ),
)( save )
